import React from "react";
import PropTypes from "prop-types";
import { ProfileModal } from "components/Profile";
import ApplicantInterviewInviteButton from "./ApplicantInterviewInviteButton";
import { useLinks, useLogFrontendEvents } from "hooks";
import { FRONTEND_EVENT_KEYS, FRONTEND_EVENTABLE_TYPES } from "constants/index";

/**
 * ApplicationDetailsModalForClient
 *
 * @param {Object}    application
 * @param {Function}  setApplication
 * @param {Boolean}   show
 */
const ApplicationDetailsModalForClient = ({ application, setApplication, show, ...props }) => {
  const links = useLinks();
  const handleClose = () => {
    setApplication(null);
  };

  // Track applicant viewed event for analytics
  useLogFrontendEvents({
    eventableId: application?.id,
    eventableType: FRONTEND_EVENTABLE_TYPES.missionRoleApplicant,
    key: FRONTEND_EVENT_KEYS.missionRoleApplicantViewed,
  });

  return (
    <ProfileModal
      application={application}
      show={show}
      handleClose={handleClose}
      id={application?.profile?.slug}
      handlePrimary={() => {
        window.open(links.public_profile(application?.profile?.uuid), "_blank");
        handleClose();
      }}
      {...props}
      tabActions={application?.id && <ApplicantInterviewInviteButton application={application} isParentOpen={show} />}
    />
  );
};

ApplicationDetailsModalForClient.propTypes = {
  application: PropTypes.object,
  setApplication: PropTypes.func,
  show: PropTypes.bool,
};

export default ApplicationDetailsModalForClient;
